import LongTermParkingProvider from 'context/LongTermParkingProvider';
import LongTermParkingNavigator from 'navigation/LongTermParkingNavigator';
import React from 'react';

const LongTermParking = () => {
  return (
    <LongTermParkingProvider>
      <LongTermParkingNavigator />
    </LongTermParkingProvider>
  );
};

export default LongTermParking;
